import { chakra } from '@chakra-ui/react'
import { IconButton } from '@verbit-ai/verbit-ui-library'

import { TRANSCRIPT_PANEL_MIN_WIDTH } from 'src/components/constants'
import { shouldForwardProp } from 'src/utils/should-forward-prop'

export const Container = chakra('div', {
    baseStyle: ({ theme }) => ({
        height: `${theme.dimensions.trancriptToolbarHeightMobile}px`,
        minWidth: TRANSCRIPT_PANEL_MIN_WIDTH,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: '8px',
        position: 'relative',
        zIndex: 1,
    }),
})

type PanelProps = {
    $isOnlyOptions: boolean
}
export const Panel = chakra<'div', PanelProps>('div', {
    baseStyle: ({ theme, $isOnlyOptions }) => ({
        width: $isOnlyOptions ? 'unset' : '100%',
        borderRadius: '12px',
        border: $isOnlyOptions ? '1px solid' : 0,
        borderColor: theme.palette.toolbar.mobilePanelBorder,
        padding: '8px',
        display: 'flex',
        flexDirection: $isOnlyOptions ? 'row' : 'row-reverse',
        alignItems: 'center',
        justifyContent: $isOnlyOptions ? 'center' : 'flex-start',
        gap: '8px',
    }),
    shouldForwardProp,
})

type InlineOptionProps = {
    $isOnlyOptions: boolean
}
export const InlineOption = chakra<typeof IconButton, InlineOptionProps>(IconButton, {
    baseStyle: ({ theme, $isOnlyOptions }) =>
        $isOnlyOptions
            ? {}
            : {
                  padding: '6px',
                  borderColor: theme.palette.toolbar.mobilePanelIconColor,
                  borderRadius: '50%',
                  svg: {
                      width: '18px',
                      height: '18px',
                      transform: 'rotate(90deg)',
                  },
              },
    shouldForwardProp,
})

export const ExtraMenuContainer = chakra('div', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.toolbar.extrasBackground,
        padding: '24px 24px 32px',
        width: '100%',
    }),
})

export const EXTRA_CHEVRON_CLASSNAME = 'extra-chevron'
export const ExtraMenuOption = chakra('button', {
    baseStyle: ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '16px',
        color: theme.palette.toolbar.extrasTextColor,
        fontSize: '18px',
        lineHeight: '28px',
        padding: '16px 0',

        [`& .${EXTRA_CHEVRON_CLASSNAME}`]: {
            marginLeft: 'auto',
        },
    }),
})

export const ExtraMenuOptionLabel = chakra('span', {
    baseStyle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
        textAlign: 'left',
    },
})

export const MediaPlayerToggleWrapper = chakra('div', {
    baseStyle: {
        flexShrink: 0,
    },
})

export const MediaPlayerWrapper = chakra('div', {
    baseStyle: {
        position: 'absolute',
        bottom: '18px',
        left: '8px',
        width: 'calc(100% - 56px)',
    },
})

export const Spacer = chakra('div', {
    baseStyle: {
        width: '100%',
    },
})

export const SwitchWrapper = chakra('div', {
    baseStyle: {
        display: 'inline-block',
        right: '0px',
        top: '0px',
        position: 'relative',
    },
})
